import React, { useEffect, useMemo, useState } from 'react';
import Link from '@/components/atoms/link';
import { CategorySpecificProps } from './types';
import useMediaQuery from '@/hooks/useMediaQuery';
import { tablet } from '@/constants/screensizes';
import Markdown from '@/components/atoms/markdown';
import CategoriesBreadcrumb from '../product-list/components/breadcrumb';
import { useParams, useSearchParams } from 'next/navigation';
import Image from '@/components/atoms/Image';
import eventBus from '@/utils/eventbus';
import Head from 'next/head';

const CategorySpecificData = ({ selectedCategory }: CategorySpecificProps) => {
  const searchParams = useSearchParams();

  const [istablet] = useMediaQuery(tablet);
  const { slug } = useParams();
  const slugString = Array.isArray(slug) ? slug.join('/') : slug || '';
  const [total, setTotal] = useState('');

  const searchQuery = searchParams.get('query');
  const searchFailed = searchParams.get('searchFailed');
  const searchValue = searchParams.get('searchValue');
  const isSearchPage = !!searchQuery;
  const [showbutton, setShowbutton] = useState(false);

  const categoriesBreadcrumb = isSearchPage
    ? [
        { name: 'Home', link: '/' },
        {
          name: 'Search Results',
          link: '',
        },
      ]
    : [
        { name: 'Home', link: '/' },
        ...slugString
          .split('/')
          .filter(Boolean)
          .map((chunk, index, arr) => ({
            name: chunk?.replace(/-/g, ' ') || chunk,
            link: `/${arr.slice(0, index + 1).join('/')}`,
          })),
      ];

  useEffect(() => {
    const handleTotalNoOfProducts = (data: any) => {
      setTotal(data);
    };

    eventBus.on('totalProducts', handleTotalNoOfProducts);

    return () => {
      eventBus.off('totalProducts', handleTotalNoOfProducts);
    };
  }, []);

  const pageTitle = useMemo(() => {
    return `Caroma Plumbers' Hub | ${
      selectedCategory?.section_with_heading_description?.title ||
      selectedCategory?.section_with_image_text?.title ||
      'See All Products'
    }${searchQuery ? ` ${searchQuery}` : ''}`;
  }, [selectedCategory, searchQuery]);

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);
  const brandRequiredPadding = ['stylus', 'dorf', 'clark'].includes(
    selectedCategory?.section_with_image_text?.title?.toLowerCase() || '',
  );
  const toggleDescription = () => {
    setShowbutton(!showbutton);
  };

  return (
    <>
      <div className="mt-5 px-5 lg:px-10">
        <CategoriesBreadcrumb breadcrumb={categoriesBreadcrumb.filter(breadCrumb => breadCrumb.name !== 'product')} />
        {!isSearchPage ? (
          selectedCategory?.section_with_heading_description ? (
            <div className="mt-10 text-center">
              <div className="text-32 font-medium leading-8 text-[#090909] lg:text-48 lg:leading-[3.25rem]">
                {selectedCategory?.section_with_heading_description?.title}
              </div>
              <div className="mt-5 text-18 font-medium leading-[1.625rem] text-[#333333]">
                {!istablet && !showbutton ? (
                  <div>
                    <Markdown className="[&>p]:line-clamp-2">
                      {selectedCategory?.section_with_heading_description?.description}
                    </Markdown>
                    {selectedCategory &&      selectedCategory?.section_with_heading_description?.description && (
                      <span
                        onClick={toggleDescription}
                        className="cursor-pointer text-blue-500 hover:underline"
                      >
                        Show More
                      </span>
                    )}
                  </div>
                ) : (
                  <>
                    <Markdown>{selectedCategory?.section_with_heading_description?.description}</Markdown>
                    {!istablet && (
                      <span onClick={toggleDescription} className="cursor-pointer text-blue-500 hover:underline">
                        Show Less
                      </span>
                    )}
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className={`mt-10 ${brandRequiredPadding ? 'flex flex-col gap-10' : ''} text-center`}>
              <div className="flex justify-center">
                <img src={selectedCategory?.section_with_image_text.image?.url} className="" alt={''} />
              </div>
              {!istablet && !showbutton ? (
                <div>
                  <Markdown className="[&>p]:line-clamp-2">
                    {selectedCategory?.section_with_image_text?.description}
                  </Markdown>
                  {selectedCategory  && (
                    <span
                      onClick={toggleDescription}
                      className="cursor-pointer text-blue-500 hover:underline"
                    >
                      Show More
                    </span>
                  )}
                </div>
              ) : (
                <div>
                  <Markdown>{selectedCategory?.section_with_image_text?.description}</Markdown>
                  {!istablet && (
                    <span onClick={toggleDescription} className="cursor-pointer text-blue-500 hover:underline">
                      Show Less
                    </span>
                  )}
                </div>
              )}
            </div>
          )
        ) : (
          <div className="mt-10 text-center">
            <div className="text-18 font-medium leading-[1.625rem] text-[#333333]">Search results for:</div>
            <div className="mt-5 text-32 font-medium leading-8 text-[#090909] lg:text-48 lg:leading-[3.25rem]">
              '{searchQuery}'
            </div>
            <div className="mt-3 text-18 font-medium leading-[1.625rem] text-[#333333]">{total} Product Results</div>
          </div>
        )}
        {searchFailed && (
          <div className="mt-10 text-center">
            <div className="mt-5 text-32 font-medium leading-8 text-[#090909] lg:text-48 lg:leading-[3.25rem]">
              {'Sorry, no matches found'}
            </div>
            <div className="mt-5 break-all text-32 font-medium leading-8 text-[#090909] lg:leading-[3.25rem]">
              '{searchValue}'
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CategorySpecificData;
